<template>
  <div class="status flex">
      <div class="status-circle " :class="getColorCircle(text)"></div>
      <div>{{text}}</div>
  </div>
</template>
<script setup>
defineProps({
  text: {
    type: String,
  },
});
const getColorCircle = (priority) => {
  if (priority?.includes('Низкий') ) {
    return 'color_gray'
  }
  if (priority?.includes('Высокий')) {
    return 'color_red'
  }
  return 'color_blue'
}
</script>
<style scoped lang="scss">
.color {
  &_blue {
    background-color: $primary-main!important;
  }
  &_red  {
    background-color: $red-main!important;
  }
  &_gray {
    background-color: $grey-pressed!important;
  }
  &_none {
    background-color: transparent;
  }
}

.status {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  color: $dark;
}

.status-circle {
  content: '';
  //position: absolute;
  //top: 29px;
  //left: 166px;
  //width: 10px;
  //height: 10px;
  align-self: center;
  margin-right: 8px;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  white-space: nowrap;
}
</style>